export default {
  path: '/factory',
  title: '优工厂',
  icon: 'industry',
  children: [
    {
      path: 'basic',
      title: '基本数据',
      icon: 'database',
      children: [
        {
          path: 'supplier',
          title: '供应商管理',
          component: 'quality/basic/supplier'
        },
        {
          path: 'customer',
          title: '客户管理',
          component: 'quality/basic/customer'
        },
        {
          path: 'review',
          title: '审核配置',
          component: 'factory/basic/review'
        }
      ]
    },
    {
      path: 'inspection',
      title: '验厂管理',
      icon: 'book',
      children: [
        {
          path: 'basic',
          title: '基础清单',
          tabCache: true,
          component: 'factory/inspection/basic'
        },
        {
          path: 'basicChecklist',
          title: '基础清单维护',
          disableMenu: true,
          disableTab: true,
          disableAuth: true,
          component: 'factory/inspection/basicChecklist'
        },
        {
          path: 'item',
          title: '验厂清单',
          tabCache: true,
          component: 'factory/inspection/item'
        },
        {
          path: 'itemChecklist',
          title: '验厂清单维护',
          disableMenu: true,
          disableTab: true,
          disableAuth: true,
          component: 'factory/inspection/itemChecklist'
        },
        {
          path: 'process',
          title: '流程配置',
          component: 'factory/inspection/process'
        }
      ]
    },
    {
      path: 'order/list',
      title: '验厂任务',
      icon: 'tasks',
      tabCache: true,
      component: 'factory/order/list'
    },
    {
      path: 'order/detail',
      title: '验厂报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'factory/order/detail/index'
    },
    {
      path: 'order/defect',
      title: '疵点报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'factory/order/detail/defect'
    },
    {
      path: 'order/history',
      title: '历史验厂报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'factory/order/detail/history'
    },
    {
      path: 'statistics',
      title: '统计管理',
      icon: 'pie-chart ',
      children: [
        {
          path: 'supplier',
          title: '供应商统计',
          component: 'factory/statistics/supplier'
        },
        {
          path: 'inspector',
          title: '质检员统计',
          component: 'factory/statistics/inspector'
        }
      ]
    }
  ]
}
